export const ColorMode = { light: "light", dark: "dark" };
//# sourceMappingURL=colorModeValue.js.map